/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown> }} Task_Catalog_Remove_DescriptionInputs */

const en_task_catalog_remove_description = /** @type {(inputs: Task_Catalog_Remove_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`It will no longer be created here. Open tasks of this activity in ${i?.scope} can only be canceled.`)
};

const pt_br2_task_catalog_remove_description = /** @type {(inputs: Task_Catalog_Remove_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ela deixa de ser criada aqui. Tarefas abertas desta atividade em ${i?.scope} só poderão ser canceladas.`)
};

/**
* | output |
* | --- |
* | "It will no longer be created here. Open tasks of this activity in {scope} can only be canceled." |
*
* @param {Task_Catalog_Remove_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_remove_description = /** @type {((inputs: Task_Catalog_Remove_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Remove_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_remove_description(inputs)
	return pt_br2_task_catalog_remove_description(inputs)
});